export default "__VITE_ASSET__DVMUct1K__"